export const DEFAULT_GATHERING_NAME = "Untitled Album";
export const GATHERING_OPEN_GRAPH_DIMENSIONS = {
	width: 900,
	height: 1440,
};
